import React from 'react';
import { TL_UNIT_COUNT_REVIEW_NOTE } from '../../data/periodClose';
import { UnderReviewBadge } from './UnderReviewBadge';

/** Amber "Under review" note: TL / Director fee rows and the bonus unit count. */
export function UnderReviewNote() {
  return <p className="flex flex-wrap items-center gap-2 rounded border border-[#F9C88C] bg-sf-amber-light px-3 py-2 text-xs text-sf-text" data-id="element-915" data-mp="3fplmhfhnyxak">
      <UnderReviewBadge data-id="element-916" data-mp="c7buquhnpgzp" />
      {TL_UNIT_COUNT_REVIEW_NOTE}
    </p>;
}